import React from 'react';
import styled from 'styled-components';

const FinalCTA = () => {
  return (
    <SectionContainer>
      <ContentWrapper>
        <CTAButton href="https://airtable.com/applMg99eyh4tG3sV/pag7Q14LFPQXgJgTi/form">
          <ButtonText>Join the beta</ButtonText>
          <ButtonArrow>→</ButtonArrow>
        </CTAButton>
        <LimitedAvailability>Limited spots available for our private beta.</LimitedAvailability>
      </ContentWrapper>
    </SectionContainer>
  );
};

const SectionContainer = styled.section`
  padding: 5rem 0 10rem;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  
  @media (max-width: 768px) {
    padding: 4rem 0 8rem;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
`;

const CTAButton = styled.a`
  font-family: 'SF Pro Text', 'Plus Jakarta Sans', sans-serif;
  background: linear-gradient(135deg, #BA865E 0%, #C4845F 100%);
  color: white;
  font-size: 17px;
  padding: 0.9rem 2.2rem;
  border-radius: 12px;
  font-weight: 500;
  letter-spacing: 0.01em;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  text-decoration: none;
  box-shadow: 0 2px 8px rgba(186, 134, 94, 0.25);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(186, 134, 94, 0.35);
    background: linear-gradient(135deg, #C4845F 0%, #BA865E 100%);
  }
`;

const ButtonText = styled.span`
  margin-right: 0.75rem;
`;

const ButtonArrow = styled.span`
  transition: transform 0.3s ease;
  font-size: 20px;
  
  ${CTAButton}:hover & {
    transform: translateX(4px);
  }
`;

const LimitedAvailability = styled.p`
  font-family: 'SF Pro Text', 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  color: #86868b;
  font-weight: 400;
  letter-spacing: 0.01em;
  opacity: 0.8;
`;

export default FinalCTA; 